import React, { useEffect, ReactNode } from "react";
import FooterAdmin from "./FooterAdmin";
import HeaderMarine from "./HeaderMarine";

type HeadProps = { title: string };
type LayoutProps = { children?: ReactNode; title?: string };

const Head: React.FC<HeadProps> = ({ title }) => {
  useEffect(() => {
    document.title = title;
  }, [title]);

  return null;
};

const MarineLayout = ({ children, title = "" }: LayoutProps) => (
  <>
    <Head title={title} />
    <>
      <HeaderMarine />

      <main className="mt-[53px] xl:mt-[58px]">{children}</main>

      <FooterAdmin />
    </>
  </>
);

export default MarineLayout;
